import { result } from "underscore";

export default class WorkspaceDataManager {

    constructor() {

    //     this.filterData = this.filterData.bind(this);
    //     this.groupData = this.groupData.bind(this);
       
    }

    static filterData(inData, identity, workspaceFilters, defaultFilters) {
        if(identity.dataSet === 'blastbidash') {
            if(workspaceFilters['storeId'] !== undefined) {
                let locationIds = workspaceFilters['storeId'].selected
                let availableHours = {columns:{}}, floorHours={columns:{}}, avhFlag = 0, fhFlag = 0;
                inData.forEach(item => {
                    if(locationIds.includes(item.columns.storeId) && item.kpiIdentifier === 'AvailableHours') {
                        if(avhFlag === 0) {
                            avhFlag++;
                            availableHours = {
                                columns: { ...item.columns },
                                ...item
                            }
                        } else if(avhFlag === 1) {
                            availableHours = {
                                ...availableHours,
                                cyCustom: availableHours.cyCustom + item.cyCustom,
                                cyValue: availableHours.cyValue + item.cyValue,
                                cyYTD: availableHours.cyYTD + item.cyYTD,
                                cyQTD: availableHours.cyQTD + item.cyQTD,
                                cyMTD: availableHours.cyMTD + item.cyMTD,
                                cyWTD: availableHours.cyWTD + item.cyWTD,
                                lyCustom: availableHours.lyCustom + item.lyCustom,
                                lyValue: availableHours.lyValue + item.lyValue,
                                lyYTD: availableHours.lyYTD + item.lyYTD,
                                lyQTD: availableHours.lyQTD + item.lyQTD,
                                lyMTD: availableHours.lyMTD + item.lyMTD,
                                lyWTD: availableHours.lyWTD + item.lyWTD
                            }
                        }
                    } else if(locationIds.includes(item.columns.storeId) && item.kpiIdentifier === 'FloorHours') {
                        if(fhFlag === 0) {
                            fhFlag++;
                            floorHours = {
                                columns: { ...item.columns },
                                ...item
                            }
                        } else if(fhFlag === 1) {
                            floorHours = {
                                ...floorHours,
                                cyCustom: floorHours.cyCustom + item.cyCustom,
                                cyValue: floorHours.cyValue + item.cyValue,
                                cyYTD: floorHours.cyYTD + item.cyYTD,
                                cyQTD: floorHours.cyQTD + item.cyQTD,
                                cyMTD: floorHours.cyMTD + item.cyMTD,
                                cyWTD: floorHours.cyWTD + item.cyWTD,
                                lyCustom: floorHours.lyCustom + item.lyCustom,
                                lyValue: floorHours.lyValue + item.lyValue,
                                lyYTD: floorHours.lyYTD + item.lyYTD,
                                lyQTD: floorHours.lyQTD + item.lyQTD,
                                lyMTD: floorHours.lyMTD + item.lyMTD,
                                lyWTD: floorHours.lyWTD + item.lyWTD
                            }
                        }
                        
                    }
                })
                let utilFinal = [];
                let finalObj = {
                    ...availableHours,
                    cyCustom: isFinite(floorHours.cyCustom*100/availableHours.cyCustom) ? floorHours.cyCustom*100/availableHours.cyCustom : 0,
                    cyValue: isFinite(floorHours.cyValue*100/availableHours.cyValue) ? floorHours.cyValue*100/availableHours.Value : 0,
                    cyYTD: isFinite(floorHours.cyYTD*100/availableHours.cyYTD) ? floorHours.cyYTD*100/availableHours.cyYTD : 0,
                    cyMTD: isFinite(floorHours.cyMTD*100/availableHours.cyMTD) ? floorHours.cyMTD*100/availableHours.cyMTD : 0,
                    cyQTD: isFinite(floorHours.cyQTD*100/availableHours.cyQTD) ? floorHours.cyQTD*100/availableHours.cyQTD : 0,
                    cyWTD: isFinite(floorHours.cyWTD*100/availableHours.cyWTD) ? floorHours.cyWTD*100/availableHours.cyWTD : 0,
                    lyCustom: isFinite(floorHours.lyCustom*100/availableHours.lyCustom) ? floorHours.lyCustom*100/availableHours.lyCustom : 0,
                    lyValue: isFinite(floorHours.lyValue*100/availableHours.lyValue) ? floorHours.lyValue*100/availableHours.lyValue : 0,
                    lyYTD: isFinite(floorHours.lyYTD*100/availableHours.lyYTD) ? floorHours.lyYTD*100/availableHours.lyYTD : 0,
                    lyMTD: isFinite(floorHours.lyMTD*100/availableHours.lyMTD) ? floorHours.lyMTD*100/availableHours.lyMTD : 0,
                    lyQTD: isFinite(floorHours.lyQTD*100/availableHours.lyQTD) ? floorHours.lyQTD*100/availableHours.lyQTD : 0,
                    lyWTD: isFinite(floorHours.lyWTD*100/availableHours.lyWTD) ? floorHours.lyWTD*100/availableHours.lyWTD : 0,
                    kpiIdentifier: 'ApptUtil',
                    columns: {...availableHours.columns, name: "Utilization Percentage", type: "PCT", prec: "2"}
                }
                utilFinal.push(finalObj);
                inData = inData.concat(utilFinal);
            }
        }
        let outData = inData.reduce((r, e) => {
            let filterSuccess = true;
            if (!identity.selectedMetrics.some(x => x.metric === e.kpiIdentifier)) {
                filterSuccess = false;
            }
            if (filterSuccess) {
                Object.keys(identity.filters).forEach((filterHeader) => {
                    if (!identity.filters[filterHeader].isAllSelected) {
                        if(filterHeader === 'storeId' || filterHeader === 'onlineStoreId') {
                            let locFilters = [];
                            if(identity.filters['onlineStoreId'] !== undefined && identity.filters['storeId'] !== undefined) {
                                locFilters = identity.filters['onlineStoreId'].selected.concat(identity.filters['storeId'].selected);
                            } else if(identity.filters['storeId'] !== undefined) {
                                locFilters = [...identity.filters['storeId'].selected];
                            }
                            if(!locFilters.includes(e.columns['storeId'])) {
                                filterSuccess = false;
                            }
                        } else {
                            if (!identity.filters[filterHeader].selected.includes(e.columns[filterHeader])) {
                                filterSuccess = false;
                            }
                        }
                    }
                });
                if (filterSuccess && (identity.dataSet === "blastsbd" || identity.dataSet === "blastbidash" || !identity.isLocked)) {
                    Object.keys(workspaceFilters).forEach(filterHeader => {
                        let tmpfilterHeader = filterHeader;
                        if (filterHeader === 'onlineStoreId') {
                            tmpfilterHeader = 'storeId';
                        } else if (identity.dataSet === "blastprod") {
                            if (filterHeader === "productCategoryId") {
                                tmpfilterHeader = "categoryId";
                            }
                            if (filterHeader === "productSubCategoryId") {
                                tmpfilterHeader = "subCategoryId";
                            }
                        } else if (identity.dataSet === "blasttreat") {
                            if (filterHeader === "treatmentCategoryId") {
                                tmpfilterHeader = "categoryId";
                            }
                            if (filterHeader === "treatmentSubCategoryId") {
                                tmpfilterHeader = "subCategoryId";
                            }
                        }
                        if (Object.keys(defaultFilters[identity.dataSet]).includes(tmpfilterHeader)) {
                            if(filterHeader === 'onlineStoreId' || filterHeader === 'storeId') {
                                let locFilters = [];
                                if(workspaceFilters['onlineStoreId'] !== undefined && workspaceFilters['storeId'] !== undefined) {
                                    locFilters = workspaceFilters['onlineStoreId'].selected.concat(workspaceFilters['storeId'].selected);
                                } else if(workspaceFilters['storeId'] !== undefined) {
                                    locFilters = [...workspaceFilters['storeId'].selected];
                                }
                                if(!locFilters.includes(e.columns[tmpfilterHeader])) {
                                    filterSuccess = false;
                                }
                            } else {
                                if (!workspaceFilters[filterHeader].selected.includes(e.columns[tmpfilterHeader])) {
                                    filterSuccess = false;
                                }
                            }
                        }
                    }
                    );
                }
            }
            if (filterSuccess) {
                r.push(e);
            }
            return r;
        }, []);
        return outData;
    }

    static groupData(inData, identity, defaultGroupings, allMaps, metricDefinitions, allData, timeFilter) {

        let outData = Object.values(inData.reduce((r, e) => {
            let key = "All Locations";

            let groupKey = ""
            if (identity.isGroupable) {
                key = "";
                identity.groupables.forEach((group) => {
                    let tmpGroup = group.substring(0, 1).toLowerCase() + group.substring(1);
                    
                    if(tmpGroup === "brandId" && allMaps !== undefined){
                        key +=  allMaps.brandMap[e.columns[tmpGroup]] + ", ";
                    }
                    else if(tmpGroup === "storeId" && allMaps !== undefined){
                        key +=  allMaps.storeMap[e.columns[tmpGroup]] + ", ";
                    }
                    else if(tmpGroup === "districtId" && allMaps !== undefined){
                        key +=  allMaps.districtMap[e.columns[tmpGroup]] + ", ";
                    }
                    else{
                        key += (e.columns[tmpGroup] ? e.columns[tmpGroup] : group) + ", ";
                    }

                    if (identity.groupables.length === 1) {
                        groupKey = group;
                    }
                });

                key = key.substring(0,key.length-2);
            } else {
                key = e.columns[defaultGroupings[identity.dataSet]];
                groupKey = defaultGroupings[identity.dataSet];
            }

            let fullKey = e.kpiIdentifier + "|" + key + "|" + e.fromDateIndex + "|" + e.dateIndex;
            let result;
            if(e.columns.isAvg === 'True') {
                let formulaKey;
                if(e.kpiIdentifier === 'PPC' || e.kpiIdentifier === 'PPG') {
                    formulaKey = e.kpiIdentifier.toLowerCase();
                } else {
                    formulaKey = e.kpiIdentifier.substring(0, 1).toLowerCase() + e.kpiIdentifier.substring(1);
                }
                if(metricDefinitions[identity.dataSet][formulaKey].jsFormula !== undefined) {
                    if(metricDefinitions[identity.dataSet][formulaKey].jsFormula !== '') {
                        let jsFormula = JSON.parse(metricDefinitions[identity.dataSet][formulaKey].jsFormula);
                        let formula = WorkspaceDataManager.computeJSFormula(jsFormula.Formula, allData, e, identity, jsFormula, timeFilter, defaultGroupings);
                        result = {
                            ...e,
                            columns: {
                                ...e.columns
                            },
                            cyCustom: formula
                        }
                    }  else {
                        result = {
                            ...e,
                            columns: {
                                ...e.columns
                            }
                        }
                    }
                } else {
                    result = {
                        ...e,
                        columns: {
                            ...e.columns
                        }
                    }
                }
            } else {
                result = {
                    ...e,
                    columns: {
                        ...e.columns
                    }
                }
            }

            if (!r[fullKey]) {
                r[fullKey] = {
                    key: key,
                    groupKey: groupKey,
                    kpiIdentifier: result.kpiIdentifier,
                    dateIndex: result.dateIndex,
                    fromDateIndex: result.fromDateIndex,
                    columns: result.columns,
                    cyCustom: result.cyCustom,
                    cyValue: result.cyValue,
                    cyWTD: result.cyWTD,
                    cyMTD: result.cyMTD,
                    cyQTD: result.cyQTD,
                    cyYTD: result.cyYTD,
                    lyCustom: result.lyCustom,
                    lyValue: result.lyValue,
                    lyWTD: result.lyWTD,
                    lyMTD: result.lyMTD,
                    lyQTD: result.lyQTD,
                    lyYTD: result.lyYTD,
                };
            } else {
                r[fullKey].cyCustom += result.cyCustom;
                r[fullKey].cyValue += result.cyValue;
                r[fullKey].cyWTD += result.cyWTD;
                r[fullKey].cyMTD += result.cyMTD;
                r[fullKey].cyQTD += result.cyQTD;
                r[fullKey].cyYTD += result.cyYTD;
                r[fullKey].lyCustom += result.lyCustom;
                r[fullKey].lyValue += result.lyValue;
                r[fullKey].lyWTD += result.lyWTD;
                r[fullKey].lyMTD += result.lyMTD;
                r[fullKey].lyQTD += result.lyQTD;
                r[fullKey].lyYTD += result.lyYTD;
            }
            return r;
        }, {}));
        return outData;
    }

    static computeJSFormula(jsFormula, dataset, element, identity, jsFormulaWrapper, timeFilter, defaultGroupings) {

		var result = 0;
		var obj1 = 0;
		var obj2 = 0;
	  
		if(jsFormula.Obj1 !== undefined) {
		  if(typeof(jsFormula.Obj1) !== "object"){
			if(isNaN(jsFormula.Obj1)){
			  if(!isNaN(Date.parse(jsFormula.Obj1))) {
				console.log('wtf')
				obj1 = jsFormula.Obj1;
			    } else {
                    if(jsFormulaWrapper.FilteredColumns.includes(jsFormula.Obj1)) {
                        if(jsFormula.Operator === 'DATEDIFF_DAY') {
                            obj1 = window.dateIndexToDate(timeFilter[jsFormula.Obj1]);
                        }
                    } else {
                        
                        dataset.forEach(el => {
                            let fullKey = '', recordKey = '';
                            if(identity.groupables.length > 0) {
                                identity.groupables.forEach(key => {
                                    let group = key.substring(0,1).toLowerCase() + key.substring(1)
                                    recordKey += element.columns[group] + ' ';
                                    fullKey += el.columns[group] + ' ';
                                })
                            }
                            let defaultGroup = defaultGroupings[identity.dataSet];
                            if(!identity.groupables.includes(defaultGroup)) {
                                recordKey += element.columns[defaultGroup] + ' ';
                                fullKey += el.columns[defaultGroup] + ' ';
                            }
                            if(fullKey === recordKey && el.kpiIdentifier === jsFormula.Obj1) {
                                obj1 = el.cyCustom;
                            } 
                        })
                    }
			    }
			}
			else {
			  obj1 = Number(jsFormula.Obj1);
			}
		  }
		  else {
			obj1 = this.computeJSFormula(jsFormula.Obj1, dataset, element, identity, jsFormulaWrapper, timeFilter, defaultGroupings)
		  }
		}
	  
		if(jsFormula.Obj2 !== undefined) {
		  if(typeof(jsFormula.Obj2) !== "object"){
			if(isNaN(jsFormula.Obj2)){
			    if(!isNaN(Date.parse(jsFormula.Obj2))) {
				    obj2 = jsFormula.Obj2;
			    } else {
                    if(jsFormulaWrapper.FilteredColumns.includes(jsFormula.Obj2)) {
                        if(jsFormula.Operator === 'DATEDIFF_DAY') {
                            obj2 = window.dateIndexToDate(timeFilter[jsFormula.Obj2]);
                        }
                    } else {
                        dataset.forEach(el => {
                            let fullKey = '', recordKey = '';
                            if(identity.groupables.length > 0) {
                                identity.groupables.forEach(key => {
                                    let group = key.substring(0,1).toLowerCase() + key.substring(1)
                                    recordKey += element.columns[group] + ' ';
                                    fullKey += el.columns[group] + ' ';
                                })
                            }
                            let defaultGroup = defaultGroupings[identity.dataSet];
                            if(!identity.groupables.includes(defaultGroup)) {
                                recordKey += element.columns[defaultGroup] + ' ';
                                fullKey += el.columns[defaultGroup] + ' ';
                            }
                            if(fullKey === recordKey && el.kpiIdentifier === jsFormula.Obj2) {
                                obj2 = el.cyCustom;
                            } 
                        })
                    }
			    }
			}
			else {
			  obj2 = Number(jsFormula.Obj2);
			}
		  }
		  else {
			obj2 = this.computeJSFormula(jsFormula.Obj2, dataset, element, identity, jsFormulaWrapper, timeFilter, defaultGroupings)
		  }
		}
	  
		switch(jsFormula.Operator) {
		  case "-":
			result = obj1 - obj2;
			break;
		  case "*":
			result = obj1 * obj2;
			break;
		  case "/":
			result = obj1 / obj2;
			break;
		  case "%":
			result = obj1 % obj2;
			break;
		  case "ABS":
			result = Math.abs(obj1);
			break;
		  case "DATEDIFF_DAY":
              result = (Math.ceil(Math.abs(new Date(obj1) - new Date(obj2)))/ (1000 * 3600 * 24)) + 1;
			break;
		  default:
			result = obj1 + obj2;
			break;
		}
        if(isNaN(result)) {
            result = 0;
        }
		return result;
	}

}